function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.375 8.688A7.688 7.688 0 1 1 1 8.688a7.688 7.688 0 0 1 15.375 0zm-1 0A6.688 6.688 0 1 0 2 8.688a6.688 6.688 0 0 0 13.375 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.354 5.354a.5.5 0 0 1 .707 0l2.474 2.474 2.475-2.474a.5.5 0 0 1 .638-.058l.07.058a.5.5 0 0 1 0 .707L9.242 8.535l2.476 2.475a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.708 0L8.535 9.242l-2.474 2.476a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.475-2.475-2.474-2.474a.5.5 0 0 1-.058-.638z"
});

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref2, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error_icon.32403b49.svg";
export { ForwardRef as ReactComponent };